/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Match } from './Match';
import {
    MatchFromJSON,
    MatchFromJSONTyped,
    MatchToJSON,
    MatchToJSONTyped,
} from './Match';

/**
 * 
 * @export
 * @interface DisputeResultResponse
 */
export interface DisputeResultResponse {
    /**
     * 
     * @type {Match}
     * @memberof DisputeResultResponse
     */
    match: Match;
    /**
     * 
     * @type {string}
     * @memberof DisputeResultResponse
     */
    message: string;
}

/**
 * Check if a given object implements the DisputeResultResponse interface.
 */
export function instanceOfDisputeResultResponse(value: object): value is DisputeResultResponse {
    if (!('match' in value) || value['match'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function DisputeResultResponseFromJSON(json: any): DisputeResultResponse {
    return DisputeResultResponseFromJSONTyped(json, false);
}

export function DisputeResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'match': MatchFromJSON(json['match']),
        'message': json['message'],
    };
}

export function DisputeResultResponseToJSON(json: any): DisputeResultResponse {
    return DisputeResultResponseToJSONTyped(json, false);
}

export function DisputeResultResponseToJSONTyped(value?: DisputeResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'match': MatchToJSON(value['match']),
        'message': value['message'],
    };
}

